<template>
  <div>
    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>
    <div class="columns is-multiline">

      <div class="column is-half">
        <!-- 서비스 기본 정보 -->
        <div class="box">
          <admin-box-item title="서비스 기본 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="서비스명" tip="브라우저의 탭, 메일, sms등에 사용되므로 필수적으로 입력이 필요하며, 글자수는 공백포함 20자로 제한됩니다. ">
                  <input class="input"
                         :value="value.title"
                         @input="e => value.title = e.target.value"
                         placeholder="런치팩"
                         type="text" maxlength="20">
                </admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item label="서비스 영문명">
                  <input class="input"
                         :value="value.title_eng"
                         @input="e => value.title_eng = e.target.value"
                         placeholder="launchpack"
                         type="text" maxlength="20">
                </admin-form-item>
              </div>-->
              <div class="column is-full">
                <admin-form-item label="기본 도메인">https://{{ $store.getters.getServiceSetting.service_key }}.{{ $store.getters.serviceType === 4 ? 'platformfy.com' : 'launchpack.co.kr' }}</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="맞춤 도메인">
                  <template v-if="domain === '' && !isMasterAdmin">
                    <button class="button is-primary-light" @click="clickReqDomain" style="width:140px">도메인 연결 신청하기</button>
                  </template>
                  <div v-else-if="domain !== '' && !isMasterAdmin">{{ domain }} </div>
                  <input class="input" v-else
                         :value="domain"
                         @input="e => domain = e.target.value"
                         placeholder="도메인 주소 입력"
                         type="text" maxlength="100">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="내 서비스팩 정보">
                  <span v-for="(pack,idx) in packages">
                    <span>{{ convertPackName(pack) }}</span> <span v-if="idx < packages.length-1">, </span>
                  </span>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 회사 소개 -->
        <div class="box">
          <admin-box-item title="회사 소개" tip="서비스의 회사소개 페이지에 표시됩니다.">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item>
                  <tab1 :tabs="[{label:'PC',value:0},{label:'모바일',value:1}]"
                        @selectedValue="val=>company_desc_index=val"></tab1>
                  <lp-editor :text.sync="value.company_desc" v-show="company_desc_index===0"></lp-editor>
                  <lp-editor :text.sync="value.company_desc_mobile" v-show="company_desc_index===1"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 고객센터 -->
        <div class="box">
          <admin-box-item title="고객센터" tip="서비스 프론트 하단에 표시되며, 프론트 디자인에 따라 표시되지 않는 항목이 있을 수 있습니다.">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="고객센터 대표번호">
                  <input class="input"
                         :value="value.service_center.call"
                         @input="e => value.service_center.call = e.target.value"
                         placeholder="010-1234-5678"
                         type="text" maxlength="20">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="팩스번호">
                  <input class="input"
                         :value="value.service_center.fax"
                         @input="e => value.service_center.fax = e.target.value"
                         placeholder="0212345678"
                         type="text" maxlength="20">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="고객센터 이메일">
                  <input class="input"
                         :value="value.service_center.email"
                         @input="e => value.service_center.email = e.target.value"
                         placeholder="launchpack@launchpack.co.kr"
                         type="text" maxlength="100">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="운영시간">
                  <input class="input"
                         :value="value.service_center.time"
                         @input="e => value.service_center.time = e.target.value"
                         placeholder="00:00~00:00"
                         type="text" maxlength="100">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="카카오플러스 고객상담 주소" :is-flex="true">
                  <lp-check-bool label="사용함" :checkedVal.sync="value.service_center.enable_kakao"></lp-check-bool>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item>
                  <input class="input"
                         :value="value.service_center.kakao_url"
                         @input="e => value.service_center.kakao_url = e.target.value"
                         placeholder="http://launchpack.kakao.com/launchpack"
                         type="text" maxlength="40">
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!--<div class="lp-bg-table">
          <div class="lp-bg-sub-header">
            <span class="lp-bg-sub-title"></span>
          </div>
          <div>
            <div class="lp-bg-devision" style="margin: 15px 0"></div>

            &lt;!&ndash; 선택된 유저 &ndash;&gt;
            <div v-for="(user, index) in value.users">
              <div class="flex" style="justify-content: flex-end">
                <i class="material-icons" @click="delUser(user, index)">close</i>
              </div>
              <table class="lp-partner-user-manage-table">
                <tbody>
                <tr>
                  <td style="width: 110px"><div class="lp-user-sub-title" style="font-size: 0.83rem">이메일 아이디</div></td>
                  <td><lp-input-text :data.sync="user.username" width="200" :disabled="true"></lp-input-text></td>
                </tr>
                <tr>
                  <td style="width: 110px"><div class="lp-user-sub-title" style="font-size: 0.83rem">담당자 이름</div></td>
                  <td><lp-input-text :data.sync="user.name" :disabled="true"></lp-input-text></td>
                </tr>
                <tr>
                  <td style="width: 110px"><div class="lp-user-sub-title" style="font-size: 0.83rem">휴대전화번호</div></td>
                  <td><lp-input-text :data.sync="user.phone" :disabled="true"></lp-input-text></td>
                </tr>
                <tr>
                  <td style="width: 110px"><div class="lp-user-sub-title" style="font-size: 0.83rem">업무용 메일</div></td>
                  <td><lp-input-text :data.sync="user.work_email" inputWidth="200px" :disabled="true"></lp-input-text></td>
                </tr>
                </tbody>
              </table>
              <div class="lp-bg-devision" style="margin: 15px 0"></div>
            </div>

            &lt;!&ndash; 선택전 유저 &ndash;&gt;
            <div v-if="visible_user">
              <table class="lp-partner-user-manage-table">
                <tbody>
                <tr>
                  <td style="width: 110px"><div class="lp-user-sub-title" style="font-size: 0.83rem">이메일 아이디</div></td>
                  <td style="text-align: left"><lp-adm-drop-input :data.sync="manager_list" @onSelect="selectUser" ref="admin_input"
                                         placeholder="검색 후 선택" width="160px" listAlign="center"
                                         style="display:inline-block; margin-right:4px;"></lp-adm-drop-input></td>
                  &lt;!&ndash;<td><lp-sort-drop-down :list="manager_list" :data="manager.username" @onSelectItem="selectUser" width="200"></lp-sort-drop-down></td>&ndash;&gt;
                </tr>
                <tr>
                  <td style="width: 110px"><div class="lp-user-sub-title" style="font-size: 0.83rem">담당자 이름</div></td>
                  <td><lp-input-text :data.sync="manager.name" maxlength="15"></lp-input-text></td>
                </tr>
                <tr>
                  <td style="width: 110px"><div class="lp-user-sub-title" style="font-size: 0.83rem">휴대전화번호</div></td>
                  <td><lp-input-text :data.sync="manager.phone" maxlength="13"></lp-input-text></td>
                </tr>
                <tr>
                  <td style="width: 110px"><div class="lp-user-sub-title" style="font-size: 0.83rem">업무용 메일</div></td>
                  <td><lp-input-text :data.sync="manager.work_email" inputWidth="200px" maxlength="30"></lp-input-text></td>
                </tr>
                </tbody>
              </table>
              <div class="lp-bg-devision" style="margin: 15px 0"></div>
            </div>
            <div @click="addPartnerManager" class="lp-add-manager">+ 관리자 담당자 추가</div>
            <div class="lp-bg-devision" style="margin: 15px 0"></div>
          </div>
        </div>-->
      </div>

      <div class="column is-half">
        <!-- 플랫폼 사업자 정보 -->
        <div class="box">
          <admin-box-item title="플랫폼 사업자 정보" tip="서비스 프론트 하단에 표시되며, 프론트 디자인에 따라 표시되지 않는 항목이 있을 수 있습니다.">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="회사(상호명)">
                  <input class="input"
                         :value="value.business_info.company"
                         @input="e => value.business_info.company = e.target.value"
                         placeholder="런치팩"
                         type="text" maxlength="20">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="사이트 저작권자명(영문)">
                  <input class="input"
                         :value="value.business_info.copyright"
                         @input="e => value.business_info.copyright = e.target.value"
                         placeholder="Launchpack Corp"
                         type="text" maxlength="50">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="사업자 등록번호">
                  <input class="input"
                         :value="value.business_info.business_num"
                         @input="e => value.business_info.business_num = e.target.value"
                         placeholder="123-45-67890"
                         type="text" maxlength="20">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="대표자명">
                  <input class="input"
                         :value="value.business_info.ceo_name"
                         @input="e => value.business_info.ceo_name = e.target.value"
                         placeholder="홍길동"
                         type="text" maxlength="15">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="개인정보보호 책임자">
                  <input class="input"
                         :value="value.business_info.privacy_manager"
                         @input="e => value.business_info.privacy_manager = e.target.value"
                         placeholder="홍길동"
                         type="text" maxlength="15">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="회사 주소">
                  <lp-address :data.sync="value.business_info.address"></lp-address>
                </admin-form-item>
              </div>


              <div class="column is-full">
                <admin-form-item label="전화번호">
                  <input class="input"
                         :value="value.business_info.call"
                         @input="e => value.business_info.call = e.target.value"
                         placeholder="010-1234-5678"
                         type="text" maxlength="20">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="팩스번호">
                  <input class="input"
                         :value="value.business_info.fax"
                         @input="e => value.business_info.fax = e.target.value"
                         placeholder="0212345678"
                         type="text" maxlength="20">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="통신판매신고번호">
                  <input class="input"
                         :value="value.business_info.ecommerce_num"
                         @input="e => value.business_info.ecommerce_num = e.target.value"
                         placeholder="제 2019-광주동구-0000 호"
                         type="text" maxlength="20">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="세금계산서 이메일주소">
                  <input class="input"
                         :value="value.business_info.email_tax"
                         @input="e => value.business_info.email_tax = e.target.value"
                         placeholder="launchpack@launchpack.co.kr"
                         type="text" maxlength="100">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="이미지">
                  <input-img :url.sync="value.business_info.img"></input-img>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="isLaunchpack">
                <admin-form-item label="입금받을 계좌 정보" v-if="value.business_info.account">
                  <div>
                    <span class="select">
                      <select v-model="value.business_info.account.bank">
                        <option value="" disabled selected>은행선택</option>
                        <option v-for="bank in banklist"
                                :value="bank.label">{{ bank.label }}</option>
                      </select>
                    </span>
                  </div>
                  <div style="margin-top:6px">
                    <input class="input"
                           style="width:350px"
                           :value="value.business_info.account.number"
                           @input="e => value.business_info.account.number = e.target.value"
                           placeholder="계좌번호를 입력하세요."
                           type="number">
                  </div>
                  <div style="margin-top:6px">
                    <input class="input"
                           style="width:250px"
                           :value="value.business_info.account.name"
                           @input="e => value.business_info.account.name = e.target.value"
                           placeholder="이름"
                           type="text">
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

    </div>

    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>

  </div>
</template>

<script>
  import BreadCrumb from '../../module/common/BreadCrumb'
  import InputImg from '../../module/common/InputImg'
  import LpInputText from '../../module/common/LpInputText'
  import LpAddress from '../../module/common/LpAddress'
  import LpCheckBool from "../../module/common/LpCheckBool";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import AdminFormItem from "../../module/admin/AdminFormItem";
  import LpEditor from "../../module/common/LpEditor";
  import Tab1 from "../../module/common/Tab1";

  export default {
    layout: 'Main',
    components: {
      Tab1,
      LpEditor,
      AdminFormItem,
      LpAdmDropInput,
      LpCheckBool,

      InputImg,
      LpInputText,
      LpAddress
    },
    created() {
      this.$axios.get('admin/service/info')
        .then(res => {
          if(res.status===200) {
            let value = res.data;
            ['company_desc_mobile', 'privacy_manager'].forEach(item => {
              if(!value[item]) {
                value[item] = '';
              }
            })
            this.value = value;

            if(this.isLaunchpack) {
              this.getBankList();
            }
            else {
              this.$axios.get('admin/service/domain')
                .then( res => {
                  if(res.status === 200) {
                    this.domain = res.data.domain.indexOf('launchpack.co.kr') === -1 &&
                    res.data.domain.indexOf('platformfy.com') === -1 ? res.data.domain : '';
                  }
                });
              this.getPackages();
            }
          }
        });
    },
    watch:{
      'value.service_center.call'(n){
        this.value.service_center.call = autoHyphenPhone(this.value.service_center.call);
      },
      'value.service_center.fax'(n){
        this.value.service_center.fax = autoHyphenPhone(this.value.service_center.fax);
      },
      'value.business_info.business_num'(n){
        this.value.business_info.business_num = autoHyphenBiz(this.value.business_info.business_num);
      },
      'value.business_info.call'(n){
        this.value.business_info.call = autoHyphenPhone(this.value.business_info.call);
      },
      'value.business_info.fax'(n){
        this.value.business_info.fax = autoHyphenPhone(this.value.business_info.fax);
      }
    },
    data () {
      return {
        company_desc_index: 0,
        visible_user:false,
        // 유저 정보
        manager:{
          username:'',
          name:'',
          position:'',
          phone:'',
          work_email:''
        },
        manager_list:[],
        banklist: [],
        domain: '',
        value:{
          title: '',
          title_eng: '',
          basic_package: '',
          service_center: {
            call: '',
            fax: '',
            email: '',
            time: '',
            kakao_url: '',
            enable_kakao: false
          },
          business_info: {
            company: '',
            business_num: '',
            ceo_name: '',
            privacy_manager: '',
            address : {
              post_code:'',
              full:'',
              sido: '',
              sigungu: '',
              dong: '',
              zipcode: '',
              detail:''
            },
            call: '',
            fax: '',
            ecommerce_num: '',
            img: '',
            email_tax: ''
          },
          // 담당자들
          users: [],
        },
        packages: []

        // 고객센터

        // 플랫폼 사업자 정보

      }
    },
    methods: {
      clickReqDomain() {
        // 앱마켓 이동
        if(this.serviceInfo.service_type === 4) {
          this.$root.$emit('appMarket', { detail: 155 });
        }
        // 1:1 문의
        else {
          this.routerPush('/office/admin/launchpack/inquiry/customer/create?cat=3');
        }
      },
      getPackages() {
        this.packages = this.$store.getters.getPackages;
      },
      delUser(user, index){
        this.$axios.post('admin/admin/delete',{
          admin_id: user.id
        }).then(res=>{
          if(res.status===200){
            this.toast('삭제되었습니다.');
            this.value.users.splice(index, 1);
          }
        })
      },
      getBankList() {
        if(!this.value.business_info.account) {
          this.value.business_info.account = {
            bank: '',
            number: '',
            name: ''
          }
        }
        this.$axios.get('public/banks').then(res=>{
          this.banklist = res.data;
        })
      },
      // 담당자 선택하기
      selectUser(res){
        this.manager.username = res.label;
        this.manager_list.filter(item=>{
          if(item.id===res.value){
            this.manager = item
          }
        })
        this.$refs.admin_input.selectedLabel = '';
      },
      addPartnerManager(){
        // 처음 추가시 작성 목록 F->T
        if(!this.visible_user){
          this.visible_user = true;
          return;
        }
        if(this.manager.id && this.value.users.length===0) {
          this.value.users.push(this.manager);
          this.manager = {
            username: '',
            name: '',
            position: '',
            phone: '',
            work_email: ''
          }
        }
        else if(this.manager.id && this.value.users.length>0){
          let user_id_arr = [];
          this.value.users.filter(item => {
            user_id_arr.push(item.id);
          })
          if(!user_id_arr.includes(this.manager.id)){
            this.value.users.push(this.manager);
            this.manager = {
              username: '',
              name: '',
              position: '',
              phone: '',
              work_email: ''
            }
          }
        }
      },
      keyupName(val) {
        this.value.title = val;
      },
      keyupNameEng(val) {
        this.value.title_eng = val;
      },
      save() {
        let errMsg = '';
        if(!this.value.title) errMsg = '서비스명을 입력하세요.';
        // else if(!this.value.title_eng) errMsg = '서비스 영문명을 입력하세요.';

        if(errMsg){
          this.toast(errMsg);
          return;
        }

        this.value.service_center.call = this.removeHyphone(this.value.service_center.call);
        this.value.service_center.fax = this.removeHyphone(this.value.service_center.fax);
        this.value.business_info.business_num = this.removeHyphone(this.value.business_info.business_num);
        this.value.business_info.call = this.removeHyphone(this.value.business_info.call);
        this.value.business_info.fax = this.removeHyphone(this.value.business_info.fax);
        this.value.business_info.ecommerce_num = this.removeHyphone(this.value.business_info.ecommerce_num);

        this.$axios.post('admin/service/domain', {domain: this.domain})
          .then( res => {
            if(res.status === 200) {
            }
          });

        this.$axios.patch('admin/service/info', this.value).then(res => {
          if(res.status === 200 && res.data.detail==='success')
            this.$store.commit('setServiceName', this.value.title);
            this.toast('서비스 기본 설정이 저장되었습니다.');
            this.saveServiceGuide('basic')
        });
      },
      removeHyphone(data){
        let phone = '';
        let phone_copy = '';
        phone = data;
        for(let i=0; i<phone.length; i++){
          phone_copy += phone[i];
        }
        return phone_copy;
      },
      getAdminList(){
        this.$axios.get('admin/admin/normal').then(res=>{
          if(res.status===200){
            this.manager_list = res.data;
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .lp-input-text-label
    margin-bottom 8px
    margin-right 8px
    display block
    color #064160
    font-weight bold
  font-size 0.83rem

  .lp-add-manager
    text-align center
    background-color #eee
    padding 12px
    color #777
    cursor pointer

  .pack-box
    border 1px solid #787878
    color #787878
    display inline-block
    padding 4px 16px
    border-radius 3px
    margin-right 8px
    font-size 14px
    cursor pointer

  .package-selected
    color $primary
    border 1px solid $primary
</style>
